import { useNavigate } from "react-router-dom";
import { ErrorCanvas } from "../components/error-canvas";
import { Button } from "../components/ui/button";

export function ServerErrorPage({ onRetry }: { onRetry?: () => void }) {
  const navigate = useNavigate();
  return (
    <div className="relative flex min-h-dvh flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <ErrorCanvas />
      </div>
      <div className="relative z-10 flex flex-col items-center px-6 text-center">
        <p className="mb-5 font-mono text-xs uppercase tracking-[0.24em] text-muted-foreground">
          Error 500
        </p>
        <h1 className="font-serif text-[clamp(72px,14vw,144px)] font-medium italic leading-[0.95] tracking-[-0.04em]">
          Broken.
        </h1>
        <p className="mt-7 max-w-[34em] text-[clamp(15px,2vw,17px)] leading-relaxed text-muted-foreground">
          Something went wrong on our end. Our team has been notified — try
          again in a moment. Your bookings are safe.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          {onRetry ? (
            <Button size="lg" onClick={onRetry}>
              Try again →
            </Button>
          ) : (
            <Button size="lg" onClick={() => window.location.reload()}>
              Try again →
            </Button>
          )}
          <Button size="lg" variant="outline" onClick={() => navigate("/")}>
            Back to dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
